import { render, staticRenderFns } from "./ParentsCard.vue?vue&type=template&id=73c138b6&"
import script from "./ParentsCard.vue?vue&type=script&lang=js&"
export * from "./ParentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports